import { useEffect } from 'react'

import pickupPositionIcon from '../assets/map-location.png'

type Props = {
  __map__?: any
  pickupPosition?: {
    lng?: any
    lat?: any
  }
}
export default (props: Props) => {
  const { __map__, pickupPosition } = props;

  // useEffect(() => {
  //   if (!__map__) return;
  //   // console.log('__map__ ______________________', __map__);
  //   // return;
  //   const geolocation = new AMap.Geolocation({
  //     enableHighAccuracy: true,//是否使用高精度定位，默认:true
  //     timeout: 8000,          //超过10秒后停止定位，默认：5s
  //     position:'RB',    //定位按钮的停靠位置
  //     offset: [20, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
  //     zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
  //   });
  //   console.log('geolocation ______________________', geolocation);

  //   geolocation.getCurrentPosition((status, result) => {
  //     console.log('getCurrentPosition suuuuuuuuuuuuuuccccess', status, result)
  //       if(status === 'complete'){
  //           // onComplete(result)
  //       }else{
  //           // onError(result)
  //       }
  //   });
  // }, [__map__]);

  useEffect(() => {
    __map__.clearMap()

    let markerPickup
    if (pickupPosition && pickupPosition.lng && pickupPosition.lat) {
      markerPickup = new window.AMap.Marker({
        position: new window.AMap.LngLat(
          pickupPosition.lng,
          pickupPosition.lat
        ),
        title: '取车地点',
        icon: new window.AMap.Icon({
          size: new AMap.Size(48, 48),
          imageSize: new AMap.Size(48, 48),
          image: pickupPositionIcon,
        }),
      })

      __map__.add(markerPickup)
    }

    if (markerPickup) {
      let markerPickupLngLat = markerPickup.getPosition()
      __map__.setCenter(markerPickupLngLat)
      __map__.setZoom(15)
    }
  }, [pickupPosition])

  return null
}
